export default "__VITE_ASSET__5fb63b09__"